import { getCookie, setCookie } from '@/app/common/cookies/clientCookies.ts';
import { COOKIE_KEY } from '@/app/common/cookies/types.ts';
import type { FilterSessionState } from '@/app/common/filters/session/sessionState.ts';
import { EMPTY_FILTER_SESSION } from '@/app/common/filters/session/sessionState.ts';
import { parseFilterSession, serialiseFilterSession } from '@/app/common/filters/session/cookieFormat.ts';

const FILTER_SESSION_COOKIE_EXPIRE_DAYS = 30;

export const readFilterSessionCookie = (): FilterSessionState => {
  try {
    return parseFilterSession(getCookie(COOKIE_KEY.FILTER_SESSION));
  } catch {
    return EMPTY_FILTER_SESSION;
  }
};

export const writeFilterSessionCookie = (state: FilterSessionState): void =>
  setCookie(COOKIE_KEY.FILTER_SESSION, serialiseFilterSession(state), FILTER_SESSION_COOKIE_EXPIRE_DAYS);
